import { Breadcumb, MainLayout } from 'components';
import Header from 'components/header/header';
import Loader from 'components/UI/loader/loader';
import React, { FC, useState, useEffect } from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import AlertModal from '../../modals/alert-modal/alert-modal';
import {
  LoaderContainer,
  Title,
  ImageUser,
  ButtonSubmit,
  FormRow,
  FormInput,
} from './style';
import Form from 'react-bootstrap/Form';
import UserInfoService from 'services/UserInfo/user-info';
import userSample from 'assets/img/user.png';
const ChangePersonalInfo: FC = () => {
  const [file, setFile] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [image, setImage] = useState('');
  const [userName, setUserName] = useState<{
    nome: string;
    sobrenome: string;
  }>();
  const userData = JSON.parse(localStorage.getItem('usuarioIES') || '{}');

  const getUserInfo = async () => {
    const user = await UserInfoService.getUserInfo();
    setUserName(user);
  };
  useEffect(() => {
    loadUserImage(userData?.id);
    getUserInfo();
  }, []);

  const loadUserImage = (userId) => {
    UserInfoService.getUserImage(userId).then((image) => {
      var url = URL.createObjectURL(image);
      setImage(url);
    });
  };

  const handleFileInput = (e) => {
    const file = e.target.files?.[0];
    setFile(file);
    var url = URL.createObjectURL(file);
    setImage(url);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const name = e.target.name.value;
    const lastName = e.target.lastName.value;
    if (!name && !lastName && !file) return;

    try {
      setIsLoading(true);
      await UserInfoService.postUserImage(name, lastName, file);
      setAlertMessage('Suas informações foram salvas.');
      setAlertOpen(true);
      setIsLoading(false);
    } catch (error) {
      setAlertOpen(true);
      setAlertMessage(error.message || 'Ocorreu um erro.');
      setIsLoading(false);
      console.log(error);
    }
  };

  return (
    <MainLayout>
      <Breadcumb />
      <Header />
      <Container>
        <Row>
          <Col>
            {isLoading && (
              <LoaderContainer>
                <Loader show={isLoading} />
              </LoaderContainer>
            )}
            <Title>Informações Pessoais</Title>

            <Form noValidate onSubmit={(e) => onSubmit(e)}>
              <ImageUser>
                <input
                  name="imageInput"
                  type="file"
                  onChange={handleFileInput}
                />
                <img
                  src={image || userSample}
                  alt="user"
                  className="img-fluid rounded-circle"
                />
                <span>Adicionar foto de perfil</span>
              </ImageUser>
              <FormRow>
                <Col xs={12} md={12} lg={5}>
                  <FormInput
                    type="text"
                    name="name"
                    disabled
                    placeholder={userName?.nome}
                  />
                </Col>
              </FormRow>
              <FormRow>
                <Col xs={12} md={12} lg={5}>
                  <FormInput
                    type="text"
                    name="lastName"
                    disabled
                    placeholder={userName?.sobrenome}
                  />
                </Col>
              </FormRow>
              <ButtonSubmit variant="primary" type="submit">
                Enviar
              </ButtonSubmit>
            </Form>
          </Col>
        </Row>
      </Container>
      <AlertModal
        title="Atenção"
        isOpen={alertOpen}
        onClose={() => {
          setAlertOpen(false);
        }}
        message={alertMessage}
      />
    </MainLayout>
  );
};

export default ChangePersonalInfo;
